<template>
<b-modal id="auction-modal" size="lg" :title="$t('AUCTION.VIEWER')">
    <div class="text-center">
        <div class="alert alert-secondary" role="alert">         
            {{ 'AUCTION.ALERT_TEXT' | translate }}
            <div class="sub-text">
                {{ 'AUCTION.ALERT_SUBTEXT' | translate }}         
            </div>
        </div>
        <div class="row content-row">
            <div class="col-md-6">

                <CardTable 
                :cards="cards" 
                :hasBetColumn="hasBetColumn"
                maxSelection="1" />

                <div class="input-container">
                    <div class="row no-gutter">
                        <div class="col-sm-6">
                            <header class="text-left">
                                {{ 'PRICE_IN_NAS' | translate }}
                            </header>
                            <input type="number" v-model="price" placeholder="0.01"/>
                        </div>
                        <div class="col-sm-6">
                            <header class="text-left">
                                {{ 'CREATED_ON' | translate }}
                            </header>
                            <input type="text" disabled v-model="today"/>
                        </div>
                    </div>
                </div>                
            </div>
            <div class="col-md-5 offset-md-1">
                <div class="card-container">
                    <Card v-for="(card, index) in selectedCards" :key="index" :card="card" actionOn="false"/>
                    <Card v-if="selectedCards.length <= 0" type="new" card="{}" actionOn="false"/>
                </div>               
            </div>
        </div>        
    </div>
    <div slot="modal-footer" class="text-center">        
        <button type="button" class="btn btn-secondary" @click="hideModal">
            {{ 'CLOSE' | translate }}
        </button>
        <button type="button" class="btn btn-primary" @click="createAuction">
            {{ 'CREATE' | translate }}
        </button>
    </div>
</b-modal>    
</template>
 
<script>
import { mapGetters } from "vuex";
import { CHARACTERS, ELEMENTS } from "../util/constants/cards";
import fees from "../util/constants/fees";
import CardTable from "./CardTable";
import Card from "./Card";

export default {
  name: "modal-auction",
  components: { Card, CardTable },
    data () {
        return {
            fees: fees,
            hasBetColumn: false,
            deadline: new Date(),
            price: 0
        }
    },
    computed: {
        ...mapGetters({
            cards: 'getCards',
            selectedCards: 'getSelectedCards'
        }),
        today () {
            return this.$moment(new Date()).format('MM/DD/YYYY');
        }
    },
    methods: {
        hideModal () {
            this.$root.$emit('bv::hide::modal','auction-modal');
        },
        createAuction () {

            // Require 1 card to auction
            if (this.selectedCards.length < 1) {
                this.$notify({
                    group: "app",
                    title: "Warning!",
                    text: "You must select 1 card!"
                });

                return;
            }

            // Confirm a future date has been selected
            const deadline = Math.round((new Date(this.deadline)).getTime() / 1000);

            // Confirm price is above 0
            const price = this.price;

            if (price <= 0) {
                this.$notify({
                    group: "app",
                    title: "Warning!",
                    text: "You must select a price above 0."
                });

                return;
            }

            const cardId = this.selectedCards[0].id;

            // Close modal before contract starts
            // because the wait could be long
            // TODO: Add modal or nav loader.
            this.hideModal();

            // Update pending status
            this.$store.commit('updatePendingTransaction', { status: true });

            // Update lock status on bet card, before transaction completes
            // TODO: Handle metamask decline use case & page refresh
            this.$store.commit('updateCardLockStatus', { id: this.selectedCards[0].id, isLocked: true, lockType: 'auction' });

            this.$store.dispatch('createAuction', { cardId, deadline, price, card: this.selectedCards[0] }).then(response => {

                if (response.message == 'error') {
                    
                    this.$notify({
                        group: 'app',
                        title: 'Error!',
                        text: 'There was a problem with your transaction!'
                    });

                } else {

                    this.$notify({
                        group: 'app',
                        title: 'Congrats!',
                        text: 'You have successfully created a new auction!'
                    });

                }
            });
        }
    }
};
</script>

<style scoped lang="less">
@import "../assets/less/modal.less";
@import "../assets/less/app.less";

.auction-modal {
    .modal-dialog {
        max-width: 800px;
    }
}

</style>


// WEBPACK FOOTER //
// src/components/ModalAuction.vue